import List from "@/components/list";
import Bus from "./Bus.js";

const Table = args => {
  const listener = args.listeners;
  const showImgs = listener.showImgs;
  // 编辑反馈建议
  function handleUpdate({ uuid }) {
    Bus.$emit("feedbackUpdate", uuid);
  }

  //反馈建议详情
  function handleInfo({ uuid }) {
    Bus.$emit("feedbackInfo", uuid);
  }

  //操作列按钮
  const Deal = ({ props: { vo } }) => {
    var butn = [];
    if (vo.row.handleStatus == 0) {
      butn = [
        "处理",
        () => handleUpdate(vo.row),
        "icon-deal",
        "feedback:update"
      ];
    } else {
      butn = ["详情", () => handleInfo(vo.row), "icon-info", "feedback:info"];
    }
    const dealConf = [butn];
    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip
            class="item"
            effect="dark"
            content={item[0]}
            v-permission={item[3]}
            placement="top"
          >
            <i class={item[2]} onClick={item[1]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const showDetail = ms => {
    showImgs(ms.map(x => x.url));
  };

  const Imgs = ({ props: { vo } }) => {
    let ms = vo.row.attachment == "" || vo.row.attachment === undefined ? [] : JSON.parse(vo.row.attachment);
    return ms.length > 0 ? (
      <div onClick={() => showDetail(ms)}>
        <img src={ms[0].url} style="width:100%" />
      </div>
    ) : (
        <div />
      );
  };

  const AccountTableConfig = [
    {
      label: "反馈人",
      prop: "feedbackUserName",
      minWidth: "100",
      showOverflowTooltip: true
    },
    {
      label: "问题类型",
      prop: "feedbackQuestionTypeName",
      minWidth: "100",
      showOverflowTooltip: true
    },
    {
      label: "反馈内容",
      prop: "feedbackContent",
      minWidth: "150",
      showOverflowTooltip: true
    },
    {
      label: "反馈图片",
      prop: "feedbackContent",
      minWidth: "150",
      showOverflowTooltip: true,
      render: vo => <Imgs vo={vo} />
    },
    {
      label: "反馈时间",
      prop: "createDate",
      minWidth: "150"
    },
    {
      label: "反馈渠道",
      prop: "feedbackChannelName",
      minWidth: "80",
      showOverflowTooltip: true
    },
    {
      label: "处理状态",
      prop: "handleStatusName",
      minWidth: "80"
    },
    {
      label: "操作",
      minWidth: "100",
      fixed: "right",
      align: "center",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <div>
      <List {...args} talbeCols={AccountTableConfig} />
    </div>
  );
};
export default Table;
